<template>
  <div>
    <!-- 数据库 -->
    <div class="databases">
      <Row :gutter="10">
        <!-- <Col span="4" style="padding-left:10px">
          <Select
            v-model="accountType"
            filterable
            :placeholder="
              $t('permission_configuration_management.group.checkByAccountType')
            "
            @on-change="searchAccountTypes()"
            :transfer="true"
          >
            <Option value="" selected>{{
              $t("permission_configuration_management.common.all")
            }}</Option>
            <Option
              :value="item.id"
              v-for="item in accountTypeList"
              :key="item.name"
              >{{ item.name }}</Option
            >
          </Select>
        </Col> -->
        <Col span="4">
          <Input
            search
            v-model="accountName"
            :placeholder="
              $t('permission_configuration_management.group.checkByAccountName')
            "
            @on-search="searchAccountName()"
          />
        </Col>
        <Col span="4">
          <Input
            search
            v-model="databaseId"
            :placeholder="$t('permission_configuration_management.resourcePermission.searchByDatabaseIdentifier')"
            @on-search="searchDatabaseId()"
          />
        </Col>
        <Col span="4">
          <Button
            type="primary"
            @click="handleShowAdd"
            v-hasPermission="[
              'permissionsConfigurationManagement:resourcePermission:add_database'
            ]"
            >{{
              $t("permission_configuration_management.group.addDatabase")
            }}</Button
          >
        </Col>
      </Row>
    </div>
    <Modal
      v-model="modal"
      :title="$t('permission_configuration_management.group.addDatabase')"
      width="80%"
      :loading="modalLoading"
      :ok-text="$t('alarms.common.add')"
      :mask-closable="false"
      :closable="false"
    >
      <Form
        :model="databasesForm"
        :label-width="100"
        ref="databasesForm"
        :rules="ruleValidate"
      >
        <!-- 搜索 -->
        <Row :gutter="16">
          <Col span="4">
            <!-- 云平台 -->
            <!-- <FormItem :label="$t('permission_configuration_management.group.cloudPlatform')" prop="accountTypeSearchKey" :label-width="60">
                        <Select v-model="databasesForm.accountTypeSearchKey" filterable @on-change="searchAccountType(databasesForm.accountTypeSearchKey)" :transfer="true" :placeholder="$t('permission_configuration_management.common.pleaseSelect')">
                            <Option :value="item.id" v-for="item in accountTypeList" :key="item.id">{{item.name}}</Option>
                        </Select>
                    </FormItem> -->
          </Col>
          <Col span="6">
            <!-- 账户 -->
            <FormItem
              :label="$t('permission_configuration_management.group.account')"
              prop="account"
              :label-width="50"
            >
              <Select
                v-model="databasesForm.account"
                @on-change="changeAccount(databasesForm.account)"
                multiple
                :max-tag-count="1"
                :transfer="true"
                :placeholder="
                  $t('permission_configuration_management.common.pleaseSelect')
                "
              >
                <Checkbox
                  v-model="singleAccount"
                  @on-change="selectAccountAll"
                  style="display: block;text-align:right;"
                  >{{ $t("alarms.common.allSelected") }}</Checkbox
                >
                <Option
                  :value="item.id"
                  v-for="(item, index) in accountList"
                  v-bind:key="index"
                  >{{ item.name }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col span="6">
            <!-- 存储区域 -->
            <FormItem
              :label="$t('permission_configuration_management.group.region')"
              prop="region"
              :label-width="50"
            >
              <Select
                @on-change="changebackupRegion(databasesForm.region)"
                v-model="databasesForm.region"
                :transfer="true"
                :placeholder="
                  $t('permission_configuration_management.common.pleaseSelect')
                "
              >
                <Option
                  :value="item.name"
                  v-for="item in regionList"
                  :key="item.id"
                  >{{ item.name }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col span="6" v-show="isDatabaseEngines">
            <!-- 数据库引擎 -->
            <FormItem
              :label="
                $t('permission_configuration_management.group.databaseEngine')
              "
              prop="databaseEngines"
              :label-width="80"
            >
              <Select
                v-model="databasesForm.databaseEngines"
                @on-change="
                  changeDatabaseEngines(databasesForm.databaseEngines)
                "
                :transfer="true"
                :placeholder="
                  $t('permission_configuration_management.common.pleaseSelect')
                "
              >
                <Option
                  :value="item.name"
                  v-for="item in databaseEnginesList"
                  :key="item.id"
                  >{{ item.name }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Button
            type="primary"
            style="float:right;"
            v-show="isShowSearch"
            @click="searchDatabaseInput()"
            >{{ $t("alarms.common.search") }}</Button
          >
        </Row>
        <Table
          :no-data-text="$t('common.noData')"
          ref="selection"
          :columns="columns"
          :loading="loading"
          :data="queryAccountDatabasesData"
          :height="400"
          @on-selection-change="getSelection"
        ></Table>
      </Form>
      <div slot="footer">
        <Button @click="handleReset('databasesForm')">{{
          $t("permission_configuration_management.common.cancel")
        }}</Button>
        <Button
          type="primary"
          @click="handleSubmit('databasesForm')"
          :loading="addloading"
          :disabled="isDisable"
          >{{
            $t("permission_configuration_management.common.confirm")
          }}</Button
        >
      </div>
    </Modal>
    <table-databases
      ref="tableDatabasesChild"
      :getAccountType="type"
    ></table-databases>
  </div>
</template>

<script>
import { getCookie } from "../../../../utils/cookieUtil.js";
import TableDatabases from "../resource_permission/TableDatabases";
var tableDatabases = TableDatabases;
export default {
  name: "AddDatabases",
  components: {
    TableDatabases
  },
  props: ["type"],
  data() {
    return {
      accountName: "",
      accountType: "",
      databaseId: "",
      databasesForm: {
        account: [],
        region: "",
        accountTypeSearchKey: "",
        databaseEngines: ""
      },
      accountTypeList: [],
      databaseEnginesList: [],
      accountList: [],
      regionList: [],
      selection: [],
      state: [
        "creating",
        "available",
        "stopping",
        "stopped",
        "shutting down",
        "terminated",
        "running",
        "incompatible-network"
      ],
      modal: false,
      modalLoading: true,
      loading: false,
      addloading: false,
      isDisable: true,
      isShowSearch: false,
      isDatabaseEngines: false,
      singleAccount: false,
      columns: [
        {
          type: "selection",
          width: 60,
          align: "center"
        },
        {
          title: this.$t("alarms.database.databaseId"),
          key: "databaseId"
        },
        {
          title: this.$t("alarms.database.engine"),
          key: "engine"
        },
        {
          title: this.$t("alarms.database.instanceType"),
          key: "type"
        },
        {
          title: this.$t("alarms.database.state"),
          key: "stateName"
        },
        {
          title: this.$t("alarms.database.region"),
          key: "region"
        }
      ],
      ruleValidate: {
        accountTypeSearchKey: [
          {
            required: true,
            message: this.$t("permission_configuration_management.resourcePermission.pleaseSelectCloudPlatform"),
            trigger: "change",
            type: "number"
          }
        ],
        databaseEngines: [
          { required: false, message: this.$t("permission_configuration_management.resourcePermission.pleaseSelectDatabaseEngine"), trigger: "change" }
        ],
        account: [
          {
            required: true,
            message: this.$t("permission_configuration_management.resourcePermission.pleaseSelectAccountName"),
            trigger: "change",
            type: "array"
          }
        ],
        region: [
          { required: true, message: this.$t("permission_configuration_management.resourcePermission.pleaseSelectStorageRegion"), trigger: "change" }
        ]
      },
      queryAccountDatabasesData: [],
      newQueryAccountDatabasesDataList: []
    };
  },
  methods: {
    // 按账户类型筛选
    searchAccountTypes: function() {
      eventBus.$emit("accountType", this.accountType);
      tableDatabases.methods.showAllDatabase();
    },
    // 按账户名称筛选
    searchAccountName: function() {
      eventBus.$emit("accountName", this.accountName);
      tableDatabases.methods.showAllDatabase();
    },
    // 按数据库ID搜索
    searchDatabaseId: function() {
      eventBus.$emit("databaseId", this.databaseId);
      tableDatabases.methods.showAllDatabase();
    },
    // 父组件调用子组件table内的方法
    queryDatabasesByGroupId() {
      this.$refs.tableDatabasesChild.queryDatabasesByGroupId();
    },
    //查询云平台
    getAccountType: function() {
      this.$api.account
        .queryCloudPlatforms("userName", getCookie(global.cookieName))
        .then(res => {
          this.accountTypeList = res.data;
        });
    },
    //切换云平台
    searchAccountType: function() {
      if (this.type == 2 || this.type == 6) {
        this.isDatabaseEngines = true;
        if (this.type == 6) {
          this.databaseEnginesList = [
            { id: 1, name: "MySQL" },
            { id: 2, name: "PostgreSQL" }
          ];
        }
      } else {
        this.isDatabaseEngines = false;
      }
      this.databasesForm.account = [];
      this.databasesForm.region = "";
      this.databasesForm.databaseEngines = "";
    },
    handleShowAdd() {
      // 清空表格
      this.queryAccountDatabasesData = [];
      this.isShowSearch = true;
      this.selectAccountByCloudPlatform();
      this.modal = true;
    },
    // 查询数据库引擎
    queryDatabaseEngines: function() {
      this.databasesForm.account = [];
      this.databasesForm.region = "";
      this.databasesForm.databaseEngines = "";
      if (this.type == 2 || this.type == 6) {
        this.isDatabaseEngines = true;
        if (this.type == 6) {
          this.databaseEnginesList = [
            { id: 1, name: "MySQL" },
            { id: 2, name: "PostgreSQL" }
          ];
          return;
        }
      } else {
        this.isDatabaseEngines = false;
      }
      this.$api.rds
        .queryDatabaseEngines("userName", getCookie(global.cookieName))
        .then(res => {
          this.databaseEnginesList = res.data;
        });
    },
    //查询账号
    selectAccountByCloudPlatform: function() {
      this.$api.groupAccountRelation
        .getAccountByGroupIdAndCloudPlatform({
          groupId: this.$route.query.id,
          accountType: this.type
        })
        .then(res => {
          this.accountList = res.data;
        });
    },
    selectAccountAll() {
      this.databasesForm.account = [];
      if (this.singleAccount) {
        this.accountList.map(item => {
          this.databasesForm.account.push(item.id);
        });
      } else {
        this.databasesForm.account = [];
      }
    },
    // 切换账户
    changeAccount: function(val) {
      if (this.databasesForm.account.length == 0) {
        return;
      }
      // 清空表格
      this.queryAccountDatabasesData = [];
      this.databasesForm.databaseEngines = "";
      this.databasesForm.region = "";
      this.isShowSearch = true;
      if (val.length === this.accountList.length && val.length != 0) {
        this.singleAccount = true;
      } else {
        this.singleAccount = false;
      }
      this.$api.account
        .queryAccountRegionsByAccountIds(
          "accountIds",
          this.databasesForm.account
        )
        .then(res => {
          this.regionList = res.data;
        });
    },
    // 切换存储区域
    changebackupRegion: function() {
      this.databasesForm.databaseEngines = "";
      this.queryAccountDatabasesData = [];
      this.isShowSearch = true;
    },
    // 数据库引擎
    changeDatabaseEngines: function() {
      this.queryAccountDatabasesData = [];
      this.isShowSearch = true;
      eventBus.$emit("engineType", this.databasesForm.databaseEngines);
    },
    getState: function(stateStr) {
      for (var i = 0; i < this.state.length; i++) {
        if (stateStr == this.state[i]) {
          return i;
        }
      }
      return -1;
    },
    // 当前选择checkbox
    getSelection: function(selection) {
      this.selection = selection;
      // 清空数组
      this.newQueryAccountDatabasesDataList = [];
      for (var i = 0; i < this.selection.length; i++) {
        // 状态
        var TableQueryDatabaseDataCopy = new Object();
        TableQueryDatabaseDataCopy.databaseId = this.selection[i].databaseId;
        TableQueryDatabaseDataCopy.name = this.selection[i].name;
        TableQueryDatabaseDataCopy.engine = this.selection[i].engine;
        TableQueryDatabaseDataCopy.state = this.selection[i].state;
        TableQueryDatabaseDataCopy.region = this.selection[i].region;
        TableQueryDatabaseDataCopy.type = this.selection[i].type;
        TableQueryDatabaseDataCopy.awsZone = this.selection[i].awsZone;
        TableQueryDatabaseDataCopy.accountId = this.selection[i].accountId;
        TableQueryDatabaseDataCopy.allocatedStorage = this.selection[
          i
        ].allocatedStorage;
        TableQueryDatabaseDataCopy.iops = this.selection[i].iops;
        TableQueryDatabaseDataCopy.serverName = this.selection[i].serverName;
        TableQueryDatabaseDataCopy.resourceGroup = this.selection[
          i
        ].resourceGroup;
        this.newQueryAccountDatabasesDataList.push(TableQueryDatabaseDataCopy);
      }

      // 选了数据 可以点击下一步
      if (this.newQueryAccountDatabasesDataList.length == 0) {
        this.isDisable = true;
      } else {
        this.isDisable = false;
      }
    },
    // 点击查询
    searchDatabaseInput: function() {
      this.loading = true;
      //数据库列表
      this.$api.rds
        .queryRDSByAccountId({
          region: this.databasesForm.region,
          accountIds: this.databasesForm.account,
          engineType: this.databasesForm.databaseEngines || null,
          groupId: this.$route.query.id
        })
        .then(res => {
          this.queryAccountDatabasesData = res.data.databaseDTOList;
          this.loading = false;
        });
    },
    // 添加
    handleSubmit: function(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          // 增加
          this.addloading = true;
          this.$api.groupDatabaseRelation
            .createRDSRelation({
              groupId: this.$route.query.id,
              databaseDTOS: this.newQueryAccountDatabasesDataList
            })
            .then(res => {
              setTimeout(() => {
                tableDatabases.methods.showAllDatabase();
                this.$refs[name].resetFields();
                this.modalLoading = false;
                this.$nextTick(() => {
                  this.modalLoading = true;
                });
                this.$Message.success(this.$t("common.addSuccess"));
                this.queryAccountDatabasesData = [];
                this.newQueryAccountDatabasesDataList = [];
                this.modal = false;
                this.addloading = false;
                this.isDisable = true;
                this.singleAccount = false;
                this.accountList = [];
                this.regionList = [];
                this.databaseEnginesList = [];
                eventBus.$emit("engineType", "");
              }, 1000);
            });
        } else {
          //解决iview 表单验证，验证提示error完成验证后，"确定"按钮一直转圈，点击不起作用问题
          this.modalLoading = false;
          setTimeout(() => {
            this.modalLoading = true;
          }, 0);
          this.$Message.error(this.$t("common.addFail"));
        }
      });
    },
    // 取消
    handleReset: function(name) {
      this.isDisable = true;
      this.modal = false;
      this.singleAccount = false;
      this.queryAccountDatabasesData = [];
      this.newQueryAccountDatabasesDataList = [];
      this.accountList = [];
      this.regionList = [];
      this.databaseEnginesList = [];
      this.$refs[name].resetFields();
      eventBus.$emit("engineType", "");
    }
  }
};
</script>

<style scoped>
/*databases*/
.databases {
  width: 100%;
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/permissions_configuration_management/resource_permission/AddDatabases.vue